import { render } from "./EquipeForm.vue?vue&type=template&id=25073ccb"
import script from "./EquipeForm.vue?vue&type=script&lang=js"
export * from "./EquipeForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__